import HttpFactory from "~/repository/http.factory";
import type { PaginatedResponse } from "~/types/shared/response/paginated.response";
import type { SelectInput } from "~/types/shared/select.input";
import type { CreateUserRequest } from "~/types/user/request/create.user.request";
import type { SecurityUserResponse } from "~/types/user/response/security.user.response";
import type { UpdateUserRequest } from "~/types/user/request/update.user.request";
import type { MessageResponse } from "~/types/shared/response/message.response";
import type { PaginationRequest } from "~/types/shared/request/pagination.request";
import type { UserResponse } from "~/types/user/response/user.response";

export default class UserClient extends HttpFactory {
  private RESOURCE = "/admin/users";
  private headers: HeadersInit = {
    "Content-type": "application/json",
  };

  async getUsers(
    request?: PaginationRequest
  ): Promise<PaginatedResponse<UserResponse>> {
    return await this.call<PaginatedResponse<UserResponse>>(
      "POST",
      `${this.RESOURCE}`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async getRoles(): Promise<SelectInput[]> {
    return await this.call<SelectInput[]>(
      "GET",
      "/admin/roles",
      this.getAuthenticationHeaders()
    );
  }

  async create(request: CreateUserRequest): Promise<SecurityUserResponse> {
    return await this.call<SecurityUserResponse>(
      "POST",
      `${this.RESOURCE}/new`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async update(
    uuid: string,
    request: UpdateUserRequest
  ): Promise<SecurityUserResponse> {
    return await this.call<SecurityUserResponse>(
      "PATCH",
      `${this.RESOURCE}/${uuid}/edit`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async getUser(uuid: string): Promise<SecurityUserResponse> {
    return await this.call<SecurityUserResponse>(
      "GET",
      `${this.RESOURCE}/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async delete(uuid: string): Promise<MessageResponse> {
    return await this.call<MessageResponse>(
      "DELETE",
      `${this.RESOURCE}/${uuid}/delete`,
      this.getAuthenticationHeaders()
    );
  }

  async getUserChoices(): Promise<SelectInput[]> {
    return await this.call<SelectInput[]>(
      "GET",
      "/users/choices",
      this.getAuthenticationHeaders()
    );
  }
}
